var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.displayStyle == "buttonWithBadge"
    ? _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          class: _vm.mergedClass,
          style: _vm.mergedStyle
        },
        [
          _c("span", { class: _vm.titleClass, style: _vm.titleStyle }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("span", { class: _vm.valueClass, style: _vm.valueStyle }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ]
      )
    : _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible"
            }
          ],
          class: _vm.mergedClass,
          style: _vm.mergedStyle
        },
        [
          _c("div", { class: _vm.titleClass, style: _vm.titleStyle }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.valueClass, style: _vm.valueStyle }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }